// extracted by mini-css-extract-plugin
export default {"El":"NavigateBack_El__bXJS3"};